// Maps notification `act` values to dashboard views and deep-link target types.
// target_type must match what the receiving section checks in its deepLink handler.
export const NAV_MAP = {
    new_message:              { view: 'talk',     target_type: 'conversation' },
    meeting_invite:           { view: 'meeting',  target_type: 'meeting' },
    meeting_updated:          { view: 'meeting',  target_type: 'meeting' },
    meeting_cancelled:        { view: 'meeting',  target_type: 'meeting' },
    meeting_rsvp:             { view: 'meeting',  target_type: 'meeting' },
    meeting_removed:          { view: 'meeting',  target_type: 'meeting' },
    meeting_forwarded:        { view: 'meeting',  target_type: 'meeting' },
    meeting_time_proposed:    { view: 'meeting',  target_type: 'meeting' },
    meeting_proposal_accepted:{ view: 'meeting',  target_type: 'meeting' },
    meeting_proposal_rejected:{ view: 'meeting',  target_type: 'meeting' },
    task_assigned:            { view: 'projects', target_type: 'task' },
    task_comment:             { view: 'projects', target_type: 'task' },
    task_status_changed:      { view: 'projects', target_type: 'task' },
    team_invite:              { view: 'teams',    target_type: 'team' },
    team_role_changed:        { view: 'teams',    target_type: 'team' },
    file_shared:              { view: 'filesync', target_type: 'file' },
    // Team notice board
    team_notice:              { view: 'teams',    target_type: 'notice' },
    // UniversalObserver — model lifecycle events
    note_created:             { view: 'notes',    target_type: 'note' },
    note_updated:             { view: 'notes',    target_type: 'note' },
    note_shared:              { view: 'notes',    target_type: 'note' },
    folder_created:           { view: 'filesync', target_type: 'folder' },
    folder_updated:           { view: 'filesync', target_type: 'folder' },
    folder_shared:            { view: 'filesync', target_type: 'folder' },
    upload_created:           { view: 'filesync', target_type: 'file' },
    upload_shared:            { view: 'filesync', target_type: 'file' },
    minisite_created:         { view: 'minisite', target_type: 'minisite' },
    minisite_updated:         { view: 'minisite', target_type: 'minisite' },
    team_created:             { view: 'teams',    target_type: 'team' },
    team_updated:             { view: 'teams',    target_type: 'team' },
    team_invite_created:      { view: 'teams',    target_type: 'team' },
    // No target — open notification sidebar only
    system:                   { view: null, target_type: null },
};

/**
 * Resolve notification data into { view, deepLink } or null.
 * Returns null when there is no navigation mapping for the act.
 */
export function resolveNotificationNav(notification) {
    const data = notification?.data ?? {};
    const mapping = NAV_MAP[data.act];

    if (!mapping) return null;

    const deepLink = data.target_id
        ? {
              target_type: data.target_type ?? mapping.target_type,
              target_id:   data.target_id,
              target_meta: data.target_meta ?? {},
          }
        : null;

    return { view: mapping.view, deepLink };
}
